import { useEffect, useState } from 'react';

import api from 'api';
import { AgentRoles } from 'api/models/payload/AgentRoles';
import { Agent, OptionInterface } from 'types';
import { getPlainText } from 'utils/dataFormatter';

export const useAgents = () => {
    const [agentOptions, setAgentOptions] = useState<OptionInterface[]>([]);

    useEffect(() => {
        const roles: { role: AgentRoles; label: string }[] = [
            { role: AgentRoles.CONSULTANT, label: 'Visa Agent (Lawyer)' },
            { role: AgentRoles.BACKOFFICE, label: 'Back Office' },
            { role: AgentRoles.SALES, label: 'Sales Agent' },
        ];

        Promise.all(
            roles.map((r) =>
                api.agents
                    .get(r.role)
                    .then((res) => ({ role: r.role, label: r.label, agents: res.data ?? [] }))
                    .catch(() => ({ role: r.role, label: r.label, agents: [] as Agent[] }))
            )
        ).then((groups) => {
            const uniqueUsers = [
                ...new Map(
                    groups
                        .flatMap((group) => group.agents)
                        .map((agent) => [
                            agent.id,
                            {
                                label: `${agent.firstname} ${agent.lastname} (${getPlainText(agent.role)})`.trim(),
                                value: agent.id,
                            },
                        ])
                ).values(),
            ];

            setAgentOptions(uniqueUsers);
        });
    }, []);

    return agentOptions;
};
